// AUTO GENERATED FILE - Changes WILL be lost.
// ja - used as 'ja' fallback
export const common_fallback = true

export const translations = {}
